import React, { Component } from 'react';
import Header from '../components/Haltes/Header';
import dynamicPortal from '../utils/dynamicPortal';

export class HalteHeaderPortal extends Component {
    render() {
        return dynamicPortal.load('.js-react-halte-header', (config) => <Header config={config} />);
    }
}

export default HalteHeaderPortal;



// WEBPACK FOOTER //
// ./src/portals/HalteHeaderPortal.js